import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Reveal from "@/components/base/Reveal";
import { externalLinks, photos } from "@/mocks/site";

/**
 * CHEF.TV is a hub. Chef Eddie G already has his own home at chefeddieg.org,
 * so this page is a simple branded signpost — it introduces the world and
 * sends visitors straight to the real thing.
 */
export default function ChefEddieGPage() {
  return (
    <SiteLayout>
      <section className="relative flex min-h-screen items-center justify-center overflow-hidden bg-foreground-950 text-background-50">
        <img
          src={photos.seated}
          alt="Chef Eddie G"
          title="Chef Eddie G"
          className="absolute inset-0 h-full w-full object-cover object-top opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/60 to-foreground-950/85" />

        <div className="relative z-10 w-full px-5 md:px-10 lg:px-16 py-32 text-center">
          <Reveal>
            <p className="eyebrow text-primary-400">World 01 · The Chef</p>
          </Reveal>

          <Reveal delay={120}>
            <h1 className="mx-auto mt-6 font-heading text-5xl leading-[0.95] sm:text-6xl md:text-8xl">
              CHEF
              <br />
              EDDIE G
            </h1>
          </Reveal>

          <Reveal delay={200}>
            <p className="mx-auto mt-7 max-w-xl font-body text-lg leading-relaxed text-background-50/75">
              Chef Eddie G has his own home on the web. This is the doorway —
              step through to his full world of food, people, places and
              stories.
            </p>
          </Reveal>

          <Reveal delay={280}>
            <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
              <a
                href={externalLinks.chefEddieG}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary"
              >
                Visit chefeddieg.org
                <i className="ri-arrow-right-up-line text-base" />
              </a>
              <Link
                to="/culinary-journeys"
                className="btn-ghost text-background-50/85 hover:bg-background-50 hover:text-foreground-950"
              >
                See the Culinary Journeys
              </Link>
            </div>
          </Reveal>

          <Reveal delay={360}>
            <p className="mt-8 font-label text-[10px] uppercase tracking-label text-background-50/45">
              chefeddieg.org opens in a new tab
            </p>
          </Reveal>
        </div>
      </section>
    </SiteLayout>
  );
}